// extracted by mini-css-extract-plugin
export default {"rowWrapper":"quote-fob-cfr_rowWrapper__zxOAL"};